export default function GeozoneRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('alerts.geozone', {
      url: '/geozone',
      template: '<ui-view></ui-view>',
      ncyBreadcrumb: {
        label: "{{'GeoZone®'}} {{'Configurations' | translate}}"
      },
      redirectTo: 'alerts.geozone.list',
      helpModuleId: 'geozones',
      helpState: 'geozones.list',
      requiredFeatures: ['geozones']
    })
    .state('alerts.geozone.list', {
      url: '/',
      helpModuleId: 'geozones',
      helpState: 'geozones.list',
      template: require('./list/list.html'),
      controller: 'GeozonesListController',
      ncyBreadcrumb: {
        skip: true
      },
      requiredFeatures: ['geozones']
    })
    .state('alerts.geozone.details', {
      url: '/detail/:geozoneId',
      helpModuleId: 'geozones',
      helpState: 'geozones.details',
      template: require('./view/view.html'),
      controller: 'GeozonesViewTableController',
      ncyBreadcrumb: {
        label: '{{geozoneDetailsBreadcrumb}}'
      },
      requiredFeatures: ['geozones']
    })
    .state('alerts.geozone.create', {
      url: '/create',
      helpModuleId: 'geozones',
      helpState: 'geozones.create',
      template: require('./create/create.html'),
      controller: 'GeozonesCreateController',
      ncyBreadcrumb: {
        label: "{{'Create New' | translate}} {{'GeoZone®'}}",
        parent: 'alerts'
      },
      requiredFeatures: ['geozones.manage']
    });
}
